import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;

  color: #334156;
  background: #ffda6c;
  border-radius: 8px;

  align-items: center;
  padding: 14px;
  max-width: 328px;
  width: 100%;
  margin: 22px auto 0;

  .alignStart {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  transition: all 0.2s;
`;

export const TextSmall = styled.p`
  font-size: 13px;
  color: #334156;
  margin-bottom: 3px;
  @media screen and (max-width: 530px) {
    font-size: 10px;
  }
`;

export const TextBold = styled.p`
  font-size: 14px;
  color: #334156;
  font-weight: bold;
  @media screen and (max-width: 530px) {
    font-size: 13px;
  }
`;
